<template>
    <div>
        <oss-dialog
            v-model="dialog"
            :title="'Ajouter un compte bancaire'"
            persistent
            :fullscreen="$vuetify.display.mobile"
            :hide-overlay="$vuetify.display.mobile"
            :actions="actions"
            :previous-display="enableBudgetInsight && wizardStep === 2"
            @previous="previous"
            @close="closeDialog()"
            prefixDataCy="CreateBankAccount-create"
        >
            <v-window
                v-model="wizardStep"
                touchless
                style="min-height: 27vh"
                :style="{
                    minWidth: '800px',
                    maxWidth: !$vuetify.display.mobile ? '850px' : undefined,
                }"
            >
                <v-window-item :value="1">
                    <v-card-title
                        :class="
                            !$vuetify.display.mobile
                                ? 'title font-weight-regular justify-space-between'
                                : 'title font-weight-regular pa-1'
                        "
                    >
                        <span>Comment souhaitez vous récuperer vos opérations bancaires ?</span>
                    </v-card-title>
                    <v-card-text class="py-0">
                        <v-list subheader lines="three">
                            <v-tooltip v-if="isTrainingOffer">
                                <template #activator="{ props }">
                                    <v-list-item
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item'
                                                : 'mb-2 px-2 oss-list-item'
                                        "
                                        v-bind="props"
                                    >
                                        <template v-slot:append>
                                            <v-btn-next />
                                        </template>
                                        <v-list-item-title
                                            >Automatiquement (recommandé)</v-list-item-title
                                        ><v-list-item-subtitle
                                            >Récupération automatique et quotidienne des opérations
                                            bancaires. Nécessite de vous connecter à votre
                                            banque</v-list-item-subtitle
                                        ></v-list-item
                                    >
                                </template>
                                <span> {{ $t("training-text.normal-text") }}</span>
                            </v-tooltip>
                            <v-list-item
                                v-else
                                :class="
                                    !$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item'
                                        : 'mb-2 px-2 oss-list-item'
                                "
                                @click="connectClicked()"
                            >
                                <template v-slot:append>
                                    <v-btn-next />
                                </template>
                                <v-list-item-title>Automatiquement (recommandé)</v-list-item-title
                                ><v-list-item-subtitle
                                    >Récupération automatique et quotidienne des opérations
                                    bancaires. Nécessite de vous connecter à votre
                                    banque</v-list-item-subtitle
                                ></v-list-item
                            >
                            <v-list-item
                                :class="
                                    !$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item'
                                        : 'mb-2 px-2 oss-list-item'
                                "
                                @click="connectMangerOne()"
                                v-if="development"
                            >
                                <template v-slot:append>
                                    <v-btn-next />
                                </template>
                                <v-list-item-title>Manager One</v-list-item-title
                                ><v-list-item-subtitle
                                    >Votre banque est Manger One ? Récupérer automatiquement et
                                    quotidiennement vos opérations bancaires et vos documents
                                    attachés.</v-list-item-subtitle
                                ></v-list-item
                            >
                            <v-list-item
                                :class="
                                    !$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item'
                                        : 'mb-2 px-2 oss-list-item'
                                "
                                @click="wizardStep = 2"
                            >
                                <template v-slot:append>
                                    <v-btn-next />
                                </template>
                                <v-list-item-title>Manuellement</v-list-item-title
                                ><v-list-item-subtitle
                                    >Récupération des opérations bancaires en important manuellement
                                    un fichier csv fourni par le site de votre
                                    banque</v-list-item-subtitle
                                ></v-list-item
                            >
                        </v-list>
                    </v-card-text>
                </v-window-item>
                <v-window-item :value="2">
                    <v-form v-model="isValid">
                        <v-card-title
                            :class="
                                !$vuetify.display.mobile
                                    ? 'title font-weight-regular justify-space-between'
                                    : 'title font-weight-regular pa-1'
                            "
                        >
                            <span>Renseignez les informations de votre compte bancaire</span>
                            <!-- <v-btn
                                    icon
                                    class="mx-1"
                                    color="primary"
                                    @click="wizardStep=3"
                                >
                                    <v-icon>$dots_vertical</v-icon>
                                </v-btn> -->
                        </v-card-title>
                        <v-card-text class="py-0">
                            <v-row no-gutters class="py-2">
                                <v-col>
                                    <v-text-field-filled
                                        outlined
                                        label="Nom du compte bancaire"
                                        v-model="bankAccountName"
                                        :rules="[rules.notEmpty]"
                                        :readlonly="readonly"
                                        data-cy="CreateBankAccount-name"
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="py-2">
                                <v-col>
                                    <v-text-field-filled
                                        outlined
                                        label="Nom externe"
                                        v-model="bankAccountExternalName"
                                        :readlonly="readonly"
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="py-2">
                                <v-col>
                                    <v-text-field-filled
                                        outlined
                                        label="IBAN"
                                        v-model="bankAccountIban"
                                        @input="onInputSetTruncatedIban(bankAccountIban)"
                                        :rules="[rules.checkIBAN]"
                                        :readlonly="readonly"
                                        density="compact"
                                        data-cy="CreateBankAccount-IBAN"
                                    />
                                </v-col>
                                <v-col>
                                    <v-text-field-filled
                                        outlined
                                        label="BIC"
                                        v-model="bankAccountBic"
                                        :rules="[rules.checkBIC]"
                                        class="pl-2"
                                        :readlonly="readonly"
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="py-2">
                                <v-col>
                                    <v-text-field-filled
                                        outlined
                                        label="Nom de la banque"
                                        readonly
                                        data-cy="CreateBankAccount-BankName"
                                        :model-value="bankName"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col>
                                    <v-text-field-filled
                                        outlined
                                        label="Identifiant créancier sepa (ICS)"
                                        v-model="bankAccountICS"
                                        :rules="[rules.checkICS]"
                                        class="pl-2"
                                        :readlonly="readonly"
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="py-2">
                                <v-col>
                                    <div
                                        class="d-flex align-center justify-start"
                                        v-if="!!budgetInsightId"
                                    >
                                        <div style="min-width: 40%">
                                            <oss-date-picker-filled
                                                v-model="importStartDate"
                                                :textFieldReadOnly="false"
                                                :notRequired="true"
                                                label="Date de début d'import"
                                                :readlonly="readonly"
                                            >
                                            </oss-date-picker-filled>
                                        </div>
                                        <div class="pl-2">
                                            <v-btn
                                                @click="deletePreviousBTDialog = true"
                                                v-if="
                                                    !!budgetInsightId &&
                                                    beforeImportStartDateBTCount
                                                "
                                                :disabled="readonly"
                                                size="small"
                                            >
                                                Supprimer les flux antérieurs
                                                <v-icon class="ml-2" size="small"
                                                    >$oss-trash
                                                </v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="py-2">
                                <v-col>
                                    <oss-date-picker-filled
                                        v-model="startAuthorizedDate"
                                        :textFieldReadOnly="false"
                                        label="Date de clôture des flux bancaires"
                                        :readlonly="readonly"
                                        :mandatory="false"
                                        :clearable="true"
                                        hide-details="auto"
                                    >
                                    </oss-date-picker-filled>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="py-2">
                                <v-col>
                                    <v-select-filled
                                        v-model="bankAccountConnect"
                                        v-if="
                                            bankAccounts &&
                                            bankAccounts.length &&
                                            ((bankId && bankAccounts.length > 1) ||
                                                (!bankId && bankAccounts.length))
                                        "
                                        label="Groupe de comptes bancaires"
                                        :disabled="!bankAccountGoupIsModifiable || readonly"
                                        :items="bankAccountsSelect"
                                        hide-details
                                        item-value="id"
                                        density="compact"
                                        :item-title="(item) => item.name"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-form>
                </v-window-item>
                <!-- <v-window-item :value="3">
                      <UsersActivitiesHistory
                            :bankAccountId="bankId"
                            v-if="wizardStep===3"
                        >
                      </UsersActivitiesHistory>
                    </v-window-item> -->
            </v-window>
            <div class="d-flex justify-end text--disabled caption" v-if="companyBudgetInsightId">
                {{ companyBudgetInsightId }} - {{ budgetInsightId }}
            </div>
        </oss-dialog>
        <oss-dialog
            v-model="deletePreviousBTDialog"
            title="Suppression des mouvements bancaires"
            @valid="deletePreviousBT()"
            :validLoading="deletePreviousBTLoading"
        >
            <div style="width: 800px">
                <!-- <h4 class="text-center">Êtes-vous sûr(e) de vouloir supprimer les mouvements bancaires antérieurs à {{formatDate(importStartDate)}} ?</h4> -->
                <h4 class="text-center" v-if="!stepData || !stepData.action">
                    &#xca;tes-vous sûr(e) de vouloir supprimer les mouvements bancaires antérieurs à
                    {{ formatDate(importStartDate) }} ?
                </h4>
                <h4 class="text-center" v-if="stepData && !!stepData.action">
                    Suppression en cours
                </h4>
                <v-progress-linear
                    color="secondary"
                    height="10"
                    buffer-value="0"
                    v-if="stepData && !!stepData.action"
                    stream
                    class="ml-0"
                    :model-value="stepData.progressValue"
                />
            </div>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import gql from "graphql-tag";
import moment from "moment-timezone";
import { User } from "../../store/store";

import UPSERT_BANK_ACCOUNT from "../../graphql/bank/UpsertBankAccount.gql";
import DELETE_BANKTRANSACTIONS from "../../graphql/bankTransaction/DeleteBABankTransactions.gql";

import { connectBank } from "../../services/bankServices";
import { DialogAction } from "../../services/dialogAction";
import { getDBFormattedDate } from "@/services/dateServices";
import {
    checkIBAN,
    checkBIC,
    getBICFromIBAN,
    onIbanChanged,
    getBankNameFromIban,
    checkICS,
} from "../../../../backend/src/common/bankAccount/bankAccountServices";
import { NotificationBase } from "../NotificationBase";
import { Component, Prop, Watch, toNative } from "vue-facing-decorator";
import { truncateInput } from "@/helpers/formInput.helper";
import { Offer_type } from "@/types/offer.types";
@Component({
    emits: ["upserted", "refresh", "closeDialog", "update:active"],
})
export class CreateBankAccount extends NotificationBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) bankId: string;
    @Prop({ default: null }) bankAccounts: any;
    @Prop({ default: "" }) companyBudgetInsightId: string;

    bankName: string = "";
    bankAccountName = "";
    bankAccountExternalName = "";
    importStartDate = null;
    startAuthorizedDate = null;
    bankAccountIban = "";
    bankAccountBic = "";
    bankAccountICS = "";
    wizardStep = 1;
    createBankAccountLoading: boolean = false;
    bankAccountConnect = "";
    budgetInsightId = "";
    beforeImportStartDateBTCount = 0;

    development = false;

    actions: any = {
        action: new DialogAction(),
    };

    get offerType(): Offer_type {
        return this.$store.state.offerType;
    }

    get isTrainingOffer(): boolean {
        if (this.offerType === Offer_type.TRAINING) {
            return true;
        }
        return false;
    }

    get readonly() {
        return !this.currentUser.profile.configuration.bankAccount.write;
    }

    get bankAccountsSelect() {
        // debugger
        let bankAccounts = null;
        if (this.bankId) {
            bankAccounts = this.bankAccounts.filter((x) => x.id !== this.bankId);
        } else {
            bankAccounts = this.bankAccounts;
        }
        bankAccounts = bankAccounts.filter(
            (x) => x.bankAccountGroup && x.id === x.bankAccountGroup.id,
        );
        return [{ name: "Aucun groupe", id: this.bankId || "" }, ...bankAccounts];
    }

    get bankAccountGoupIsModifiable() {
        const bankAccountGroupListNumber = this.bankAccounts.filter(
            (x) => x.bankAccountGroup && x.bankAccountGroup.id === this.bankId,
        ).length;
        return bankAccountGroupListNumber <= 1;
    }

    get dialog() {
        return this.active;
    }

    set dialog(event) {
        this.$emit("update:active", event);
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    enableBudgetInsightBankAccount(bankAccount) {
        return (
            bankAccount?.company?.budgetInsightToken ||
            this.currentUser?.profile?.configuration.bankAccount.write
        );
    }

    get enableBudgetInsight() {
        for (const bankAccount of this.bankAccounts) {
            if (!this.enableBudgetInsightBankAccount(bankAccount)) {
                return false;
            }
        }
        return true;
    }

    onInputSetTruncatedIban(value) {
        this.bankAccountIban = truncateInput(value, 34);
    }
    previous() {
        this.wizardStep = 1;
    }

    @Watch("bankId")
    onBandIdChanged() {
        this.wizardStep = 1;
        if (this.bankId || !this.enableBudgetInsight) {
            this.wizardStep = 2;
        }
        this.onWizardStepChanged();
    }

    @Watch("wizardStep")
    onWizardStepChanged() {
        switch (this.wizardStep) {
            case 1:
                this.actions.action.display = false;
                this.actions.action.disabled = false;
                this.actions.action.loading = false;
                this.actions.action.title = "";
                this.actions.action.function = null;
                break;
            case 2:
                this.actions.action.display = true;
                this.actions.action.disabled = () => {
                    return !this.isValid || this.readonly;
                };
                this.actions.action.loading = () => {
                    return this.createBankAccountLoading;
                };
                this.actions.action.title = () => {
                    return this.bankId ? "Modifier" : "Créer";
                };
                this.actions.action.function = this.createBankAccount;
                break;
        }
    }

    beforeMount() {
        this.onBandIdChanged();
        this.addListener("bankTransaction");
    }

    beforeDestroy() {
        this.removeListener();
    }

    async connectClicked() {
        this.dialog = false;
        await connectBank(this.$apollo, this.companyId);
    }

    async connectMangerOne() {
        const {
            data: {
                managerOneURL: { url },
            },
        } = await this.$apollo.query({
            query: gql`
                query ($companyId: ID!) {
                    managerOneURL(data: { companyId: $companyId }) {
                        url
                    }
                }
            `,
            variables: {
                companyId: this.companyId,
            },
        });
        window.location.href = url;
    }

    get rules() {
        return {
            notEmpty: (value) => {
                return !!value || this.$t("settings.itemRequired");
            },
            checkIBAN: (value) => {
                return !value || checkIBAN(value) || this.$t("settings.wrongIBAN");
            },
            checkBIC: (value) => {
                return !value || checkBIC(value) || this.$t("settings.wrongBIC");
            },
            checkICS: (value) => {
                return !value || checkICS(value) || this.$t("settings.wrongICS");
            },
        };
    }

    onIbanChanged(bankAccount) {
        onIbanChanged(bankAccount);
    }

    isValid: boolean = true;

    async createBankAccount() {
        this.createBankAccountLoading = true;
        let formatConnection = null;
        if (this.bankAccountConnect) {
            formatConnection = { connect: { id: this.bankAccountConnect } };
        } else {
            if (this.bankId) {
                formatConnection = { connect: { id: this.bankId } };
            } else {
                formatConnection = undefined;
            }
        }
        let result: any = null;
        debugger;
        try {
            result = await this.$apollo.mutate({
                mutation: UPSERT_BANK_ACCOUNT,
                variables: {
                    bankId: this.bankId,
                    companyId: this.companyId,
                    name: this.bankAccountName?.trim() || "",
                    externalName: this.bankAccountExternalName,
                    iban: this.bankAccountIban || null,
                    creditorIdentifier: this.bankAccountICS || null,
                    bic: this.bankAccountBic,
                    bankAccountGroupUpdate: formatConnection,
                    bankAccountGroupCreate: formatConnection,
                    importStartDate: this.importStartDate
                        ? getDBFormattedDate(this.importStartDate)
                        : undefined,
                    startAuthorizedDate: this.startAuthorizedDate
                        ? getDBFormattedDate(this.startAuthorizedDate)
                        : undefined,
                },
            });
            this.$emit("upserted", result.data?.upsertBankAccount);
        } catch (e) {
            console.error("Error upserting bank account", e);
        }
        this.refresh();
        this.dialog = false;
        this.createBankAccountLoading = false;
    }

    refresh() {
        this.$emit("refresh");
    }

    @Watch("bankId")
    bankIdChange() {
        if (this.bankId) {
            const account = this.bankAccounts.find((x) => x.id === this.bankId);
            if (account) {
                this.bankAccountName = account.name;
                this.bankAccountExternalName = account.externalName || "";

                this.bankAccountBic = account.bic || "";
                this.bankAccountConnect = account.bankAccountGroup
                    ? account.bankAccountGroup.id
                    : "";
                this.bankAccountIban = account.iban;
                this.bankAccountICS = account.creditorIdentifier;

                if (!this.bankAccountBic && this.bankAccountIban) {
                    this.bankAccountBic = getBICFromIBAN(this.bankAccountIban);
                }

                if (!this.bankName && this.bankAccountIban) {
                    this.bankName = getBankNameFromIban(this.bankAccountIban);
                }

                this.importStartDate = account.importStartDate
                    ? moment(account.importStartDate).format("YYYY-MM-DD")
                    : null;
                this.startAuthorizedDate = account.startAuthorizedDate
                    ? moment(account.startAuthorizedDate).format("YYYY-MM-DD")
                    : null;
                this.budgetInsightId = account.budgetInsightId;

                this.beforeImportStartDateBTCount = account.beforeImportStartDateBTCount;
            }
        } else {
            this.bankName = "";
            this.bankAccountName = "";
            this.bankAccountExternalName = "";
            this.importStartDate = null;
            this.startAuthorizedDate = null;
            this.bankAccountIban = "";
            this.bankAccountICS = "";
            this.bankAccountBic = "";
            this.bankAccountConnect = "";
            this.beforeImportStartDateBTCount = 0;
        }
    }

    @Watch("bankAccountIban")
    bankIbanChange() {
        if (this.bankAccountIban?.length >= 9) {
            if (this.bankAccountIban.includes(" ")) {
                this.bankAccountIban = this.bankAccountIban.replaceAll(/\s/g, "");
            }
            this.bankName = getBankNameFromIban(this.bankAccountIban) || "";

            this.bankAccountBic = getBICFromIBAN(this.bankAccountIban) || "";
        }
    }

    closeDialog() {
        this.createBankAccountLoading = false;
        this.$emit("closeDialog");
    }

    //
    // delete
    //

    deletePreviousBTDialog = false;
    deletePreviousBTLoading = false;

    async deletePreviousBT() {
        this.deletePreviousBTLoading = true;
        if (this.importStartDate) {
            const result = await this.$apollo.mutate({
                mutation: DELETE_BANKTRANSACTIONS,
                variables: {
                    bankAccountId: this.bankId,
                    endDate: getDBFormattedDate(this.importStartDate),
                },
            });

            if (result.data?.deleteBankTransactions?.notificationId) {
                this.setNotificationStepData(
                    result.data.deleteBankTransactions.notificationId,
                    this.onRunning,
                    this.onEnded,
                );
            }
        }

        // this.deletePreviousBTDialog = false
        // this.deletePreviousBTLoading = false
    }

    onRunning() {
        this.deletePreviousBTLoading = true;
    }

    onEnded() {
        this.deletePreviousBTLoading = false;
        this.deletePreviousBTDialog = false;
        this.resetNotificationStepData();
        this.refresh();
    }

    formatDate(date) {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).format("DD/MM/YYYY");
    }
}

export default toNative(CreateBankAccount);
</script>
